module.exports = __webpack_public_path__ + "img/channel-student1.4076071f.jpg";